import { gql } from '@apollo/client';

export const VEHICLE_SEARCH = gql`
query VEHICLE_SEARCH_QUERY($perPage: Int, $page: Int, $json: String, $originatorId: ID!) {
  searchVehicles(perPage: $perPage, page: $page, json: $json, originatorId: $originatorId) {
    id
    vehicleMake {
      id
      nhtsaId
      name
    }
    vehicleModel {
      id
      nhtsaId
      name
    }
    vehicleVin {
      id
      name
    }
    vehiclePlate {
      id
      name
    }
    vehicleState {
      id
      name
    }
    incidents {
      id
      incidentNumber
      vehicleIncidentSpecifics {
        id
        vehicle {
          id
        }
      }
    }
    year
  }
}
`;

